import {
  EntrancePlantDetailDTO,
  EntrancePlantInfoCreateDTO,
} from '@/../client-generator/generated-clients/plants';
import { mapState } from 'vuex';
import { Options, Vue } from 'vue-class-component';
import { SET_APP_LOADING } from '@/core/store/action-types';
import plantsClient from '@/core/services/plants';
import CallModeForm from '@/views/components/CallModeForm/CallModeForm.vue';

@Options({
  name: 'CallModeTab',
  props: {
    infoPlant: {
      type: EntrancePlantInfoCreateDTO,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant', 'adminView']),
  },
  components: {
    CallModeForm,
  },
  emits: ['update-list'],
})
export default class CallModeTab extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  adminView!: boolean;
  infoPlant!: EntrancePlantDetailDTO;
  editedInfoPlant: EntrancePlantDetailDTO = new EntrancePlantInfoCreateDTO();

  get saveDisabled() {
    const addresTypeChanged =
      this.editedInfoPlant.addressingType !== this.infoPlant.addressingType;
    const sortingChanged =
      this.editedInfoPlant.addressBookSorting !==
      this.infoPlant.addressBookSorting;
    const brfaNamingChanged = this.checkIfBrfaNamingChanged();
    const callingCodeShowAddressBookChanged =
      this.editedInfoPlant.callingCodeShowAddressBook !==
      this.infoPlant.callingCodeShowAddressBook;
    return (
      !addresTypeChanged &&
      !sortingChanged &&
      !brfaNamingChanged &&
      !callingCodeShowAddressBookChanged
    );
  }

  get callModeHelpDescription() {
    return this.$t('AppResourceEP.CallModeHelpDescription').split('\n');
  }

  mounted(): void {
    this.initializeData();
  }

  initializeData() {
    this.editedInfoPlant = new EntrancePlantInfoCreateDTO({
      addressBookSorting: this.infoPlant.addressBookSorting,
      addressingType: this.infoPlant.addressingType,
      denominationApartments: this.infoPlant.denominationApartments,
      denominationBuildings: this.infoPlant.denominationBuildings,
      denominationFloors: this.infoPlant.denominationFloors,
      denominationRisers: this.infoPlant.denominationRisers,
      callingCodeShowAddressBook: this.infoPlant.callingCodeShowAddressBook,
    });
  }

  checkIfBrfaNamingChanged(): boolean {
    const buildNamingChanged =
      this.editedInfoPlant.denominationBuildings !==
      this.infoPlant.denominationBuildings;
    const riserNamingChanged =
      this.editedInfoPlant.denominationRisers !==
      this.infoPlant.denominationRisers;
    const floorNamingChanged =
      this.editedInfoPlant.denominationFloors !==
      this.infoPlant.denominationFloors;
    const apartmentNamingChanged =
      this.editedInfoPlant.denominationApartments !==
      this.infoPlant.denominationApartments;

    return (
      buildNamingChanged ||
      riserNamingChanged ||
      floorNamingChanged ||
      apartmentNamingChanged
    );
  }

  async handleChangeCallMode() {
    this.$store.dispatch(SET_APP_LOADING, true);
    if (!this.adminView) await this.saveCallMode();
    else this.editedInfoPlant = new EntrancePlantInfoCreateDTO(this.infoPlant);
    this.$emit('update-list');

    this.$store.dispatch(SET_APP_LOADING, false);
  }

  async saveCallMode() {
    if (this.currentEntrancePlant.desktopId === undefined) return;
    try {
      this.infoPlant.addressBookSorting = this.editedInfoPlant.addressBookSorting;
      this.infoPlant.addressingType = this.editedInfoPlant.addressingType;
      this.infoPlant.denominationApartments = this.editedInfoPlant.denominationApartments;
      this.infoPlant.denominationBuildings = this.editedInfoPlant.denominationBuildings;
      this.infoPlant.denominationFloors = this.editedInfoPlant.denominationFloors;
      this.infoPlant.denominationRisers = this.editedInfoPlant.denominationRisers;
      this.infoPlant.callingCodeShowAddressBook = this.editedInfoPlant.callingCodeShowAddressBook;

      await plantsClient.editinfo(
        this.currentEntrancePlant.desktopId,
        this.infoPlant
      );
    } catch (error) {
      console.log(error);
      setTimeout(() => {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          closable: false,
          life: 3000,
        });
      }, 1500);
    }
  }
}
